// extracted by mini-css-extract-plugin
module.exports = {"root":"Quote_root__y41JY","saasRoot":"Quote_saasRoot__3dYqr","alerts":"Quote_alerts__IX6Wg","buttons":"Quote_buttons__TdJLB"};